/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { SC } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { PersonalLinksCardFiled } from "src/modules/pe-landing-module/data/interfaces"
import { getClassNameByDesignLinkType } from "src/modules/pe-landing-module/data/utils/getClassNameByDesignLinkType"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ICardFieldProps } from "../cards/CardField"

/* Protopia Ecosystem component */
const CardFieldPersonalLinks = (props: ICardFieldProps): JSX.Element => {
    const { value, section, i} = props 
    const field: PersonalLinksCardFiled = props.field as PersonalLinksCardFiled
    useEffect(() => {
            addCSSClass(
                `divider-${section.id}`,
                `.divider-${section.id} {
                    width: ${getCssDemention(field.divider_width, "100%")}!important;
                    
                }            
                `
            )
        },[]) 
        
    const style = { 
        ...field.style, 
        ...value.style 
    }    
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-personal-link landing-card-field-personal-link ${field.className || ""} ${value.className || ""}`} 
        style={ style } 
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        {
            Object.values( SC )
                .map(sc => {
                    return !!value.data?.sc && !!value.data?.sc[sc]
                        ?
                        <div className="mx-1" key={sc}>
                            <a 
                                className={`soc hover ${getClassNameByDesignLinkType( field.personalLinkType || value.data?.type )} ${sc}`} 
                                href={value.data?.sc[sc]} 
                                target="_blank" 
                                rel="noreferrer"
                            >
                                <i 
                                    className={`${sc === SC.AT ? "fas" : "fab"} fa-${sc === SC.TELEGRAM ? `${sc}-plane` : sc}`} 
                                />
                            </a>
                        </div>
                        :
                        null
                })
        }
    </div>
}
export default CardFieldPersonalLinks